module.exports = __webpack_public_path__ + "img/Bank Islam.a4ea875a.png";